/* eslint-disable react/destructuring-assignment */
import Text from '@deprecated-ui/common/Text';
import If from 'global/ErrorHandlers/If';
import color from '@deprecated-ui/_style/color';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Image from 'global/Image';
import PasswordField from './PasswordField';
import PasswordValidation, { IPasswordValidation } from './PasswordValidation';

interface SectionPasswordField {
  error?: string;
  showForgotLink?: boolean;
  onSubmit: () => void;
  preventSubmit?: boolean;
  submitText: string;
  inputPlaceHolder?: string;
  title: string;
  subTitle?: string;
  password: string;
  onChangePassword: (p: string) => void;
  passwordValidation?: IPasswordValidation;
  onForgotPassword?: () => void;
}

const SectionPasswordField = ({
  error,
  showForgotLink,
  onSubmit,
  preventSubmit,
  submitText,
  inputPlaceHolder,
  title,
  subTitle,
  password,
  onChangePassword,
  passwordValidation,
  onForgotPassword,
}: SectionPasswordField) => (
  <Flex height="455px" direction="column" justify="space-between">
    <div style={{ width: '100%', position: 'relative' }}>
      <Image
        src="/icon/lock.svg"
        width="70px"
        height="70px"
        alt="lock"
        style={{ marginBottom: '18px' }}
      />
      <div style={{ paddingBottom: '18px' }}>
        <Text weight={700}>{title}</Text>
        {subTitle && (
          // @ts-expect-error
          <Text color="#858585" pt="10px">
            {subTitle}
          </Text>
        )}
      </div>

      <PasswordField
        error={error}
        onChange={(e) =>
          e?.target?.value?.length <= 18
            ? onChangePassword(e?.target?.value)
            : () => {}
        }
        value={password}
        placeholder={inputPlaceHolder}
      />
      <If condition={showForgotLink}>
        <Text
          color={color.primary}
          weight="700"
          // @ts-expect-error
          mt="-10px"
          style={{ position: 'absolute', right: '0px', cursor: 'pointer' }}
          onClick={onForgotPassword}
        >
          Forgot Password?
        </Text>
      </If>
      <If condition={Boolean(passwordValidation)}>
        <PasswordValidation
          uppercase={passwordValidation?.uppercase}
          lowercase={passwordValidation?.lowercase}
          number={passwordValidation?.number}
          characters={passwordValidation?.characters}
        />
      </If>
    </div>

    <Button
      block
      type="primary"
      height="44px"
      radius="4px"
      onClick={onSubmit}
      disabled={preventSubmit}
    >
      <b>{submitText}</b>
    </Button>
  </Flex>
);

export default SectionPasswordField;
